import { generateId } from "../utils/helpers";

export const templateOptions = [
  {
    id: "toronto",
    name: "Toronto",
    description:
      "A web-inspired resume template perfect for tech professionals.",
    imageUrl: "/templates/toronto.svg",
    category: "modern",
    previewData: {
      layout: "single-column",
      features: ["skill-bars", "timeline", "avatar"],
      accentColor: "#2563EB",
    },
  },
  // {
  //   id: "stockholm",
  //   name: "Stockholm",
  //   description: "Clean and functional design for all experience levels.",
  //   imageUrl: "/templates/stockholm.svg",
  //   category: "simple",
  //   previewData: {
  //     layout: "two-column",
  //     features: ["minimal", "sidebar", "clean-type"],
  //     accentColor: "#111827"
  //   }
  // },
  // {
  //   id: "london",
  //   name: "London",
  //   description: "Classic structure perfect for traditional industries.",
  //   imageUrl: "/templates/london.svg",
  //   category: "professional",
  //   previewData: {
  //     layout: "single-column",
  //     features: ["traditional", "formal", "structured"],
  //     accentColor: "#1F2937"
  //   }
  // },
  // {
  //   id: "dublin",
  //   name: "Dublin",
  //   description: "Creative layout with a touch of personality.",
  //   imageUrl: "/templates/dublin.svg",
  //   category: "creative",
  //   previewData: {
  //     layout: "asymmetric",
  //     features: ["creative-header", "dynamic-sections", "custom-icons"],
  //     accentColor: "#059669"
  //   }
  // },
  // {
  //   id: "newyork",
  //   name: "New York",
  //   description: "Professional timeline-based layout for experienced professionals.",
  //   imageUrl: "/templates/newyork.svg",
  //   category: "professional",
  //   previewData: {
  //     layout: "timeline",
  //     features: ["experience-focus", "achievement-highlights", "executive"],
  //     accentColor: "#0F172A"
  //   }
  // },
  // {
  //   id: "vienna",
  //   name: "Vienna",
  //   description: "Modern two-column design with striking header.",
  //   imageUrl: "/templates/vienna.svg",
  //   category: "modern",
  //   previewData: {
  //     layout: "two-column",
  //     features: ["bold-header", "skills-focus", "modern-type"],
  //     accentColor: "#7C3AED"
  //   }
  // },
  // {
  //   id: "sydney",
  //   name: "Sydney",
  //   description: "Bold and modern design for creative professionals.",
  //   imageUrl: "/templates/sydney.svg",
  //   category: "creative",
  //   previewData: {
  //     layout: "modular",
  //     features: ["portfolio-section", "skill-circles", "creative-layout"],
  //     accentColor: "#0D9488"
  //   }
  // },
  // {
  //   id: "berlin",
  //   name: "Berlin",
  //   description: "Minimalist design perfect for tech and startups.",
  //   imageUrl: "/templates/berlin.svg",
  //   category: "simple",
  //   previewData: {
  //     layout: "single-column",
  //     features: ["minimalist", "tech-focused", "clean-space"],
  //     accentColor: "#374151"
  //   }
  // },
  // {
  //   id: "tokyo",
  //   name: "Tokyo",
  //   description: "Tech-focused template with skills visualization.",
  //   imageUrl: "/templates/tokyo.svg",
  //   category: "modern",
  //   previewData: {
  //     layout: "grid",
  //     features: ["skill-matrix", "code-style", "tech-aesthetic"],
  //     accentColor: "#DC2626"
  //   }
  // },
  // {
  //   id: "paris",
  //   name: "Paris",
  //   description: "Elegant design balancing creativity and professionalism.",
  //   imageUrl: "/templates/paris.svg",
  //   category: "creative",
  //   previewData: {
  //     layout: "asymmetric",
  //     features: ["elegant-type", "creative-sections", "balanced-design"],
  //     accentColor: "#9D174D"
  //   }
  // },
];

export function getTemplateData(type) {
  switch (type) {
    case "toronto":
    case "stockholm":
    case "berlin":
      return fresherTemplate;
    case "london":
    case "vienna":
    case "sydney":
      return experiencedTemplate;
    case "newyork":
    case "tokyo":
      return seniorTemplate;
    case "dublin":
    case "paris":
      return leadTemplate;
    default:
      return fresherTemplate;
  }
}
export const fresherTemplate = {
  personalInfo: {
    fullName: "Alex Johnson",
    title: "Computer Science Graduate",
    email: "alex@example.com",
    phone: "(555) 123-4567",
    location: "San Francisco, CA",
    github: "github.com/alexj",
    linkedin: "linkedin.com/in/alexj",
  },
  summary:
    "Recent Computer Science graduate with strong foundation in software development and programming principles. Proficient in Java, Python, and web technologies. Seeking to leverage my technical skills to develop innovative solutions as a Junior Developer.",
  skills: [
    "Java",
    "Python",
    "JavaScript",
    "HTML/CSS",
    "React",
    "SQL",
    "Git",
    "Problem Solving",
    "Teamwork",
  ],
  experience: [
    {
      id: generateId(),
      company: "Tech Solutions Inc.",
      position: "Software Developer Intern",
      location: "San Francisco, CA",
      startDate: "2023-05",
      endDate: "2023-08",
      description:
        "Participated in the development of a web application using React and Node.js.",
      achievements: [
        "Collaborated with a team of 5 developers to implement new features",
        "Developed and maintained RESTful APIs",
        "Fixed 15+ bugs improving application stability",
      ],
    },
  ],
  projects: [
    {
      id: generateId(),
      name: "Student Management System",
      description:
        "A web-based application to manage student records and grades.",
      technologies: ["Java", "Spring Boot", "MySQL", "Thymeleaf"],
      link: "github.com/alexj/student-management",
    },
    {
      id: generateId(),
      name: "Personal Portfolio",
      description:
        "A responsive portfolio website to showcase projects and skills.",
      technologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      link: "github.com/alexj/portfolio",
    },
  ],
  education: [
    {
      id: generateId(),
      school: "University of California, Berkeley",
      degree: "Bachelor of Science",
      fieldOfStudy: "Computer Science",
      startDate: "2019-09",
      endDate: "2023-05",
      description:
        "GPA: 3.7/4.0. Relevant courses: Data Structures, Algorithms, Database Systems, Web Development.",
    },
  ],
  certifications: [
    {
      id: generateId(),
      name: "Web Development Bootcamp",
      issuer: "Udemy",
      date: "2022-06",
      link: "udemy.com/certificate/web-dev-bootcamp",
    },
  ],
};

export const experiencedTemplate = {
  personalInfo: {
    fullName: "Taylor Morgan",
    title: "Full Stack Software Engineer",
    email: "taylor@example.com",
    phone: "(555) 987-6543",
    location: "Austin, TX",
    website: "taylormorgan.dev",
    github: "github.com/tmorgan",
    linkedin: "linkedin.com/in/tmorgan",
  },
  summary:
    "Full Stack Software Engineer with 4 years of experience developing web applications using JavaScript, React, and Node.js. Proven track record of delivering scalable, high-performance applications through agile methodologies. Passionate about writing clean, maintainable code and solving complex problems.",
  skills: [
    "JavaScript",
    "TypeScript",
    "React",
    "Node.js",
    "Express",
    "MongoDB",
    "PostgreSQL",
    "AWS",
    "Docker",
    "CI/CD",
    "Agile",
  ],
  experience: [
    {
      id: generateId(),
      company: "Web Innovations Inc.",
      position: "Full Stack Developer",
      location: "Austin, TX",
      startDate: "2021-03",
      endDate: "Present",
      description:
        "Develop and maintain web applications for enterprise clients.",
      achievements: [
        "Led development of a customer portal that reduced support tickets by 35%",
        "Implemented CI/CD pipeline reducing deployment time by 40%",
        "Optimized database queries resulting in 50% faster page load times",
        "Mentored 3 junior developers to improve team velocity",
      ],
    },
    {
      id: generateId(),
      company: "StartUp Labs",
      position: "Frontend Developer",
      location: "Remote",
      startDate: "2019-06",
      endDate: "2021-02",
      description: "Built responsive web interfaces for SaaS applications.",
      achievements: [
        "Refactored legacy UI code reducing bundle size by 30%",
        "Developed reusable component library adopted across 5 products",
        "Implemented automated testing improving code coverage to 85%",
      ],
    },
  ],
  projects: [
    {
      id: generateId(),
      name: "E-commerce Platform",
      description:
        "A full-stack e-commerce solution with payment processing and inventory management.",
      technologies: ["React", "Node.js", "Express", "MongoDB", "Stripe API"],
      link: "github.com/tmorgan/ecommerce-platform",
    },
    {
      id: generateId(),
      name: "Task Management Application",
      description:
        "A Kanban-style task management application with real-time updates.",
      technologies: ["React", "Firebase", "Material UI", "Redux"],
      link: "github.com/tmorgan/task-manager",
    },
  ],
  education: [
    {
      id: generateId(),
      school: "Texas State University",
      degree: "Bachelor of Science",
      fieldOfStudy: "Computer Science",
      startDate: "2015-09",
      endDate: "2019-05",
      description: "GPA: 3.6/4.0. Minor in Mathematics.",
    },
  ],
  certifications: [
    {
      id: generateId(),
      name: "AWS Certified Developer - Associate",
      issuer: "Amazon Web Services",
      date: "2022-01",
      link: "aws.amazon.com/certification/verify",
    },
    {
      id: generateId(),
      name: "MongoDB Developer Certification",
      issuer: "MongoDB University",
      date: "2021-05",
      link: "mongodb.com/university/certification",
    },
  ],
};

export const seniorTemplate = {
  personalInfo: {
    fullName: "Jordan Rivera",
    title: "Senior Software Engineer",
    email: "jordan@example.com",
    phone: "(555) 456-7890",
    location: "Seattle, WA",
    website: "jordanrivera.tech",
    github: "github.com/jrivera",
    linkedin: "linkedin.com/in/jrivera",
  },
  summary:
    "Senior Software Engineer with 8+ years of experience architecting and developing enterprise applications. Expertise in distributed systems, microservices, and cloud infrastructure. Strong technical leadership skills with a focus on code quality, performance, and scalability. Proven ability to mentor teams and deliver projects on time and within budget.",
  skills: [
    "JavaScript",
    "TypeScript",
    "Go",
    "Java",
    "React",
    "Node.js",
    "Microservices",
    "AWS",
    "Kubernetes",
    "Docker",
    "CI/CD",
    "System Design",
    "Technical Leadership",
    "Performance Optimization",
  ],
  experience: [
    {
      id: generateId(),
      company: "Enterprise Solutions Inc.",
      position: "Senior Software Engineer",
      location: "Seattle, WA",
      startDate: "2020-01",
      endDate: "Present",
      description:
        "Lead the design and development of cloud-native applications for enterprise clients.",
      achievements: [
        "Architected and led implementation of a microservices platform that increased system reliability by 99.9%",
        "Reduced cloud infrastructure costs by 40% through optimization and right-sizing resources",
        "Mentored team of 7 engineers, improving code quality and reducing technical debt",
        "Implemented automated testing strategy increasing test coverage from 60% to 90%",
      ],
    },
    {
      id: generateId(),
      company: "Tech Innovations Corp",
      position: "Software Engineer II",
      location: "Seattle, WA",
      startDate: "2017-03",
      endDate: "2019-12",
      description:
        "Developed and maintained core services for a SaaS platform.",
      achievements: [
        "Led migration from monolith to microservices architecture",
        "Implemented real-time data processing pipeline handling 5M+ events per day",
        "Reduced API response times by 70% through optimization and caching strategies",
      ],
    },
    {
      id: generateId(),
      company: "Digital Solutions LLC",
      position: "Software Engineer",
      location: "Portland, OR",
      startDate: "2015-06",
      endDate: "2017-02",
      description:
        "Developed web applications and APIs for clients in financial sector.",
      achievements: [
        "Built secure authentication system for financial applications",
        "Implemented data visualization dashboard for financial analytics",
        "Contributed to open-source libraries for data processing",
      ],
    },
  ],
  projects: [
    {
      id: generateId(),
      name: "Distributed Caching System",
      description:
        "An open-source distributed caching system for high-throughput applications.",
      technologies: ["Go", "Redis", "gRPC", "Prometheus", "Kubernetes"],
      link: "github.com/jrivera/distributed-cache",
    },
    {
      id: generateId(),
      name: "Performance Monitoring Tool",
      description:
        "A real-time performance monitoring and alerting system for microservices.",
      technologies: [
        "TypeScript",
        "Node.js",
        "Elasticsearch",
        "Grafana",
        "Docker",
      ],
      link: "github.com/jrivera/perf-monitor",
    },
  ],
  education: [
    {
      id: generateId(),
      school: "University of Washington",
      degree: "Master of Science",
      fieldOfStudy: "Computer Science",
      startDate: "2013-09",
      endDate: "2015-05",
      description: "Focus on Distributed Systems and Cloud Computing",
    },
    {
      id: generateId(),
      school: "Oregon State University",
      degree: "Bachelor of Science",
      fieldOfStudy: "Computer Science",
      startDate: "2009-09",
      endDate: "2013-05",
      description: "Minor in Mathematics",
    },
  ],
  certifications: [
    {
      id: generateId(),
      name: "AWS Certified Solutions Architect - Professional",
      issuer: "Amazon Web Services",
      date: "2022-04",
      link: "aws.amazon.com/certification/verify",
    },
    {
      id: generateId(),
      name: "Certified Kubernetes Administrator (CKA)",
      issuer: "Cloud Native Computing Foundation",
      date: "2021-11",
      link: "cncf.io/certification/cka",
    },
    {
      id: generateId(),
      name: "Google Professional Cloud Architect",
      issuer: "Google Cloud",
      date: "2020-07",
      link: "cloud.google.com/certification",
    },
  ],
};

export const leadTemplate = {
  personalInfo: {
    fullName: "Casey Wilson",
    title: "Engineering Manager / Technical Lead",
    email: "casey@example.com",
    phone: "(555) 789-0123",
    location: "Boston, MA",
    website: "caseywilson.com",
    linkedin: "linkedin.com/in/caseywilson",
  },
  summary:
    "Results-driven Engineering Manager with 10+ years of experience leading development teams and delivering high-impact software products. Strong background in system architecture, agile methodologies, and technology strategy. Proven track record of building and mentoring high-performing teams, driving innovation, and aligning technical solutions with business objectives.",
  skills: [
    "Technical Leadership",
    "Team Management",
    "Software Architecture",
    "Agile/Scrum",
    "Project Management",
    "DevOps",
    "Cloud Architecture",
    "Strategic Planning",
    "Product Development",
    "Staff Mentoring",
    "Budget Management",
    "Cross-functional Collaboration",
  ],
  experience: [
    {
      id: generateId(),
      company: "Global Tech Solutions",
      position: "Engineering Manager",
      location: "Boston, MA",
      startDate: "2021-02",
      endDate: "Present",
      description:
        "Lead a team of 15 engineers developing enterprise SaaS products for financial services industry.",
      achievements: [
        "Increased team velocity by 35% through process improvements and strategic hiring",
        "Reduced production incidents by 70% by implementing robust CI/CD and testing practices",
        "Led technical strategy resulting in successful launch of 3 major product initiatives",
        "Managed $2.5M annual budget while delivering all projects on-time and within budget",
        "Implemented mentorship program improving team retention rate to 95%",
      ],
    },
    {
      id: generateId(),
      company: "Innovative Software Inc.",
      position: "Senior Technical Lead",
      location: "Boston, MA",
      startDate: "2018-05",
      endDate: "2021-01",
      description:
        "Led architecture and development of cloud-native applications while managing a team of 8 engineers.",
      achievements: [
        "Architected microservices platform supporting 1M+ daily users",
        "Directed migration of legacy systems to AWS reducing operational costs by 50%",
        "Established engineering best practices and technical documentation standards",
        "Led cross-functional initiatives collaborating with product, design, and business teams",
      ],
    },
    {
      id: generateId(),
      company: "TechCorp",
      position: "Senior Software Engineer",
      location: "Cambridge, MA",
      startDate: "2015-03",
      endDate: "2018-04",
      description:
        "Developed distributed systems and led feature teams for enterprise data platform.",
      achievements: [
        "Technical lead for data processing pipeline handling 10TB+ daily",
        "Mentored junior engineers and implemented code review process",
        "Represented engineering in client-facing meetings and product planning",
      ],
    },
    {
      id: generateId(),
      company: "Software Solutions LLC",
      position: "Software Engineer",
      location: "New York, NY",
      startDate: "2012-07",
      endDate: "2015-02",
      description:
        "Developed web and mobile applications for enterprise clients.",
      achievements: [
        "Implemented responsive web applications using modern JavaScript frameworks",
        "Developed RESTful APIs and backend services",
        "Contributed to internal tooling and developer experience improvements",
      ],
    },
  ],
  projects: [
    {
      id: generateId(),
      name: "Enterprise Data Platform",
      description:
        "Led architecture and implementation of scalable data platform processing petabytes of financial data.",
      technologies: [
        "AWS",
        "Kubernetes",
        "Apache Kafka",
        "Terraform",
        "Java",
        "Python",
      ],
    },
    {
      id: generateId(),
      name: "Engineering Excellence Program",
      description:
        "Developed a mentorship and training program for engineering team members to improve skills and career growth.",
      technologies: ["Internal Tools", "Agile", "Python"],
    },
  ],
  education: [
    {
      id: generateId(),
      school: "Massachusetts Institute of Technology",
      degree: "Master of Science",
      fieldOfStudy: "Computer Science",
      startDate: "2009-09",
      endDate: "2011-06",
      description: "Focus on Distributed Systems and Software Engineering.",
    },
    {
      id: generateId(),
      school: "Boston University",
      degree: "Bachelor of Science",
      fieldOfStudy: "Computer Science",
      startDate: "2005-09",
      endDate: "2009-06",
      description: "Graduated with honors.",
    },
  ],
  certifications: [
    {
      id: generateId(),
      name: "Certified ScrumMaster (CSM)",
      issuer: "Scrum Alliance",
      date: "2019-05",
      link: "scrumalliance.org/certifications",
    },
    {
      id: generateId(),
      name: "AWS Certified Solutions Architect - Professional",
      issuer: "Amazon Web Services",
      date: "2018-04",
      link: "aws.amazon.com/certification/verify",
    },
  ],
};
